import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';

import { RecipeFilterProvider } from '@/context/recipeFilter';

// components
import RecipeFilterApp from '@/components/organisms/Recipe/RecipeFilterApp';

export default () => {
  const el = document.getElementById('js-recipe-filters-r-entry');
  if (el) {
    i18n.loadNamespaces(['recipe', 'search', 'listing'], () => {
      const App = () => (
        <I18nextProvider i18n={i18n}>
          <Suspense fallback={<div />}>
            <RecipeFilterProvider>
              <RecipeFilterApp {...el.dataset} />
            </RecipeFilterProvider>
          </Suspense>
        </I18nextProvider>
      );
      ReactDOM.render(<App />, el);
    });
  }
};
